import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { clsx } from 'clsx';

export const CategoryFilter = ({ activeCategory, onCategoryChange }) => {
  const categories = [
    { id: 'all', label: 'All Categories', icon: FiIcons.FiGrid },
    { id: 'Procurement', label: 'Procurement', icon: FiIcons.FiShoppingCart },
    { id: 'Reporting', label: 'Reporting', icon: FiIcons.FiFileText },
    { id: 'Financial', label: 'Financial', icon: FiIcons.FiDollarSign },
    { id: 'Contract', label: 'Contract', icon: FiIcons.FiFile },
    { id: 'Audit', label: 'Audit', icon: FiIcons.FiShield }
  ];

  return (
    <div className="flex gap-2 overflow-x-auto pb-2">
      {categories.map(cat => (
        <button
          key={cat.id}
          onClick={() => onCategoryChange(cat.id)}
          className={clsx(
            "px-3 py-1.5 rounded-lg text-xs font-medium transition-all flex items-center gap-1.5 whitespace-nowrap",
            activeCategory === cat.id
              ? "bg-grn-navy text-white"
              : "bg-white border border-slate-200 text-slate-600 hover:border-grn-navy/30"
          )}
        >
          <SafeIcon icon={cat.icon} />
          {cat.label}
        </button>
      ))}
    </div>
  );
};